export const defaultData = {
  overview: {
    consolidated: {
      subjects: 0,
      datapoints: 0,
      datalinks: 0
    },
    own: {
      subjects: 0,
      datapoints: 0,
      datalinks: 0
    },
    acquired: {
      subjects: 0,
      datapoints: 0,
      datalinks: 0
    }
  },
  items: [],
  stakeholders: {
    own: 0,
    acquired: 0,
    datapoints: 0,
    subjects: [],
  },
  locations: {
    own: 0,
    acquired: 0,
    datapoints: 0,
    subjects: [],
  },
  events: {
    own: 0,
    acquired: 0,
    datapoints: 0,
    subjects: [],
  },
  documents: {
    own: 0,
    acquired: 0,
    datapoints: 0,
    subjects: [],
  },
  partners: {
    sources: 0,
    clients: 0
  },
  accumulation: {
    datapoints: {},
    subjects: {}
  },
  triangulation: {
    multipleSources: 0,
    singleSources: 0
  },
}
